"use client"
export const SolidAdmin = () => {
  return (
    <div>SolidAdmin</div>
  )
}